import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **Allora (Avvio)**
 *
 * @exports bs_435
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  let refreshPrice;

  /**
   *
   * @memberOf module:bs_435
   *
   * @param {object} ctx - The context object.
   */
  engine.boot = function boot() {
    const container = document.querySelector('#avvio-lodiv');
    if (container) {
      let refreshPage = thn.debounce(() => {
        thn.pageCheck();
      }, 400);

      thn.observeDom(container, refreshPage, {
        attributes: true,
        childList: true,
      });

      thn.shutdown(() => {
        refreshPage.cancel();
        thn.stopObserveDom(container, refreshPage);
        refreshPage = null;
      });
    }

  };

  /**
     * @memberOf module:bs_435
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
  engine.isUserLogged = function isUserLogged(ctx) {
    const isLogged = !document.querySelector('#login_container_not_logged_in span')?.textContent?.match(/login/i);
    return isLogged;
  };

  /**
   * @memberOf module:bs_435
   * @this thn.widgets.price
   * @see {@link Price#observe_dom}
   *
   * @param {object} ctx - The context object.
   */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    const resultContainer = document.querySelector('#section_mainpage');

    if (resultContainer) {
      refreshPrice = thn.debounce(() => {
        thn.widgets.price.refresh();
      }, 600);

      thn.observeDom(resultContainer, refreshPrice, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      });

      thn.pageUnload(() => {
        refreshPrice.cancel();
        thn.stopObserveDom(resultContainer, refreshPrice);
        refreshPrice = null;
      });
    }
  };

  /**
     * @memberOf module:bs_435
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    // https://secure.castanheiroboutiquehotel.com/convert/site/Castanheiro%20Boutique%20Hotel/en/results.php?checkin=2024-01-20&nights=1&currency=GBP&resultViewType=mda&viewtype=roomrate&partya=1
    // https://secure.cullodenestateandspa.com/convert/site/Hastings%20Culloden%20Hotel/en/results.php?av=search&checkin=2024-10-01&party=Adults%2CChildren&partya=1
    const url = new URL(ctx.baseUrl);
    const validUrl = url.pathname.match(/results/i);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    url.searchParams.set('checkin', '[date_begin]');
    url.searchParams.set('start', '[date_begin]');
    url.searchParams.set('nights', '[nights]');

    ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');

    // Export into ctx.newUrl
    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
    *
    * @memberOf module:bs_435
    *
    */
  const roomDetailsParseData = (numAdults, numChildren, nights) => {
    const roomsArray = [...document.querySelectorAll('[id*="room"].resultsection, .card-grid--rate-primary, .card-grid--room')];

    if (thn.empty(roomsArray)) {
      return {};
    }

    const roomsInfo = roomsArray
      .map((room) => {
        let roomName = room.querySelector('[class*="rnl"], .card-grid__title h4, .heading')?.textContent;
        const roomType = getRoomType(roomName);
        const ratesInfo = [...room.querySelectorAll('[id*="mdarateroom"], .item, .card-grid--room')]
          ?.map((rate) => {
            roomName = !roomName ? rate.querySelector('div a')?.textContent?.trim() : roomName;
            const rateName = (rate.querySelector('.rateTitle, .card-grid__title h5, .paragraph span') ?? rate.closest('.card-grid--rate')?.querySelector('.card-grid__title'))?.textContent?.trim();
            const ratePrice = thn.parseNumber(rate.querySelector('.price, .display-price')?.textContent);
            const isRefundable = !!room.querySelector('.avvio-incentives__item')?.textContent?.match(/Free Cancellation/i) || !rateName?.match(/non refundable|não reembolsável/i);
            const isBreakfastIncluded = !!rateName.match(/breakfast/);
            const rateData = {
              id: '',
              name: rateName,
              totalNight: ratePrice / nights,
              breakfast: isBreakfastIncluded,
              refundable: isRefundable,
            };

            return rateData;
          });
        return {
          id: '',
          name: roomName,
          adults: numAdults,
          children: numChildren,
          type: roomType,
          prices: ratesInfo,
        };

      });

    return roomsInfo;
  };

  /**
     * @memberOf module:bs_435
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v1 = function priceParseData(ctx) {

    const widgetData = {};
    const dataLayer = window.dataLayer;
    let nights;

    // Dates
    const dateBegin = thn.objectGet(dataLayer, 'arrivalDateSearch', { first: false });
    const dateEnd = thn.objectGet(dataLayer, 'departureDateSearch', { first: false });

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
      widgetData.dateEnd = dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }

    // Rooms info
    const roomsInfo = [];
    const rooms = [...document.querySelectorAll('.itemprices>table')];
    rooms.map((room) => {
      const roomNumber = thn.parseNumber(room.previousElementSibling?.textContent?.split('(')?.[0]);
      const adults = thn.parseNumber(room.querySelector('.sda-party-prompt')?.textContent);
      const prices = [...room.querySelectorAll('.price>[id*=price_mrsel]')].map((price) => thn.parseNumber(price?.textContent));

      // Existing room
      const existingRoom = roomsInfo.find((item) => item.roomNumber === roomNumber);
      if (existingRoom) {
        existingRoom.price = existingRoom.price.concat(prices);
      } else {
        roomsInfo.push({
          price: prices,
          roomNumber: roomNumber,
          adults: adults || 2,
          children: 0,
          childrenAges: [],
        });
      }
      return null;
    });

    // Prices & Currency || No Rooms || guests
    let price;
    const currency = thn.parseCurrency(document.querySelector('.top-filter-currency span')?.textContent) || thn.objectGet(dataLayer, 'currencySelected', { first: false });

    // Multiple rooms
    if (roomsInfo.length > 1) {
      widgetData.roomsDispo = roomsInfo;
      price = roomsInfo.map((room) => Math.min(...room.price)).reduce((a, b) => a + b, 0);

    } else { // Single room
      const adults = thn.parseNumber(thn.objectGet(dataLayer, 'numAdultsSearch', { first: false }));
      const children = thn.parseNumber(thn.objectGet(dataLayer, 'numChildrenSearch', { first: false }));
      widgetData.adults = adults || 2;
      widgetData.children = children || 0;
      widgetData.guests = widgetData.adults + widgetData.children;
      price = thn.parseNumber([...document.querySelectorAll('.sdacontainer .price [data-curr]')].map((el) => el.textContent).filter(Boolean).sort((a, b) => a - b)[0]);
    }

    // No availability
    const noAvailability = !!document.querySelector('#noavail');

    if (price && currency && nights) {
      widgetData.price = price / nights;
      widgetData.currency = currency;
      widgetData.roomDetails = roomDetailsParseData(widgetData.adults, widgetData.children, nights);
      widgetData.set = true;
    } else if (noAvailability) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_435
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v2 = function priceParseData_v2(ctx) {

    const widgetData = {};
    const dataLayer = window.dataLayer;
    let nights;

    // Dates
    const dateBegin = thn.objectGet(dataLayer, 'arrivalDateSearch', { first: false });
    const dateEnd = thn.objectGet(dataLayer, 'departureDateSearch', { first: false });

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
      widgetData.dateEnd = dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }

    // Guests, Adults & Children
    const roomsArray = thn.parseUrlParameter('partya')?.split(';');
    let roomsData;

    if (roomsArray[0] !== '') {
      roomsData = roomsArray.map((room) => {
        const guests = room.split(',') || [];
        const adults = thn.parseNumber(guests.slice(0, 1)) || 2;
        const childrenAges = guests.slice(1).map((age) => thn.parseNumber(age));
        const children = childrenAges.length || 0;
        return {
          adults: adults,
          children: children,
          childrenAges,
        };
      });

      widgetData.roomsDispo = roomsData;
    } else {
      widgetData.adults = 1;
      widgetData.children = 0;
    }

    const adults = roomsData?.[0]?.adults ?? widgetData.adults;
    const children = roomsData?.[0]?.children ?? widgetData.children;

    // Prices & Currency || No Rooms
    const currency = thn.parseCurrency(document.querySelector('.currency-symbol.display-currency .price.display-price')?.textContent) || document.querySelector('#currency')?.value;
    const prices = [...document.querySelectorAll('.card-information__price .price.display-price')].filter((priceEl) => thn.isVisible(priceEl)).map((price) => thn.parseNumber(price.textContent));
    const noAvailability = !!document.querySelector('.unavailable-message-box');
    if (prices.length && nights && currency) {
      widgetData.price = (Math.min(...prices) / nights);
      widgetData.currency = currency;
      widgetData.roomDetails = roomDetailsParseData(adults, children, nights);
      widgetData.set = true;
    } else if (noAvailability || !prices.length) {
      widgetData.noRooms = true;
    }
    return widgetData;
  };

  /**
     * @memberOf module:bs_435
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const dataLayer = window.dataLayer;
    const bookingId = thn.objectGet(dataLayer, 'bookingRef', { first: false });

    if (!bookingId) {
      widgetData.set = false;
      return widgetData;
    }

    // Booking ID
    widgetData.bookingId = bookingId;

    // Dates
    const dateBegin = thn.objectGet(dataLayer, 'checkinDate', { first: false })?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
    const dateEnd = thn.objectGet(dataLayer, 'checkoutDate', { first: false })?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
    widgetData.dateBegin = dateBegin;
    widgetData.dateEnd = dateEnd;

    // Adults & Children & Guests
    const adults = thn.parseNumber(thn.objectGet(dataLayer, 'occupancyAdults', { first: false }));
    const children = thn.parseNumber(thn.objectGet(dataLayer, 'occupancyChildren', { first: false }));
    const infants = thn.parseNumber(thn.objectGet(dataLayer, 'occupancyInfants', { first: false }));
    widgetData.adults = adults;
    widgetData.children = children + infants;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Price & Currency || Rooms
    widgetData.price = thn.parseNumber(thn.objectGet(dataLayer, 'transactionTotal', { first: false }));
    widgetData.currency = thn.parseCurrency(thn.objectGet(dataLayer, 'currencySelected', { first: false }));
    widgetData.rooms = thn.parseNumber(thn.objectGet(dataLayer, 'numRooms', { first: false })) || 1;

    return widgetData;
  };

  return engine;

}

export { factory };
